import { render } from "./TestReportList.vue?vue&type=template&id=2e6f8005&scoped=true"
import script from "./TestReportList.vue?vue&type=script&lang=js"
export * from "./TestReportList.vue?vue&type=script&lang=js"

import "./TestReportList.vue?vue&type=style&index=0&id=2e6f8005&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Management_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6f8005"]])

export default __exports__